<template lang="html">
  <form class="form-box-1" @submit.prevent='submit'>
    <div class="fields-23">
      <FormField addMargin='5px' :inline='1' :value='form.externalID' placeholder="ID / Title" labelText='ID / Title' :onUpdate='e => { form.externalID = e }' />
      <FormField addMargin='5px' :inline='1' :def='0' placeholder="Country" labelText='Country'>
        <select v-model='form.country' class="def select-234">
          <option value="">No filter</option>
          <option v-for='(title, option) in countryOptions' :value='option'>{{title}}</option>
        </select>
      </FormField>
      <FormField addMargin='5px' :inline='1' :def='0' placeholder="Os" labelText='Os'>
        <select v-model='form.os' class="def select-234">
          <option value="">No filter</option>
          <option v-for='(title, option) in osOptions' :value='option'>{{title}}</option>
        </select>
      </FormField>
      <FormField addMargin='5px' :inline='1' :value='form.inPixel' placeholder="in offer url" labelText='In Offer URL' :onUpdate='e => { form.inPixel = e }' />
      <FormField addMargin='5px' :inline='1' :value='form.inOfferName' placeholder="in offer name" labelText='In Offer Name' :onUpdate='e => { form.inOfferName = e }' />
      <div class="active-only-row">
        <label>Active only:</label>
        <input type="checkbox" v-model='form.activeOnly' class="checkbox-input" />
      </div>
    </div>

    <div class="btns">
      <div class="control-btn">
        <button type="submit" class="btn btn-primary" :disabled="processing">Search</button>
        <button type="button" class="btn _btn-white" @click='resetFilter'>Reset Filter</button>
      </div>
    </div>
  </form>
</template>

<script>
import * as act from "@/act-types";

export default {
  props: {
    onSubmit: {}
  },
  data() {
    let emptyForm = {
      externalID: null,
      country: null,
      os: null,
      activeOnly: true,
      inPixel: null,
      inOfferName: null,
      type: "stag"
    }
    return {
      emptyForm,
      form: Object.assign({}, emptyForm),
      processing: false,
      countryOptions: [],
      osOptions: {
        ios: "iOS",
        android: "Android"
      },
      typeOptions: {
        stag: "Script Tag",
        internal: "Internal Placement",
        external: "External Placement"
      }
    };
  },
  methods: {
    submit() {
      this.processing = true
      this.onSubmit(this.form)
      .then(() => {
        this.processing = false
      })
      .catch(() => {
        this.processing = false
      })
    },
    resetFilter() {
      this.form = Object.assign({}, this.emptyForm)
    }
  },
  created() {
    this.$store.dispatch(act.GET_COUNTRIES_LIST).then(countries => {
      this.countryOptions = Object.assign({}, {'WW': 'World Wide'}, countries)
    })

    let query = this.$route.query
    let editPlacementID = query.placement_id
    if(editPlacementID) {
      this.form.externalID = editPlacementID
      this.submit()
    }
  }
};
</script>

<style lang="css" scoped>
.form-box-1 {
}
.fields-23 {
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-content: start;
  gap: 0 0;
  margin-bottom: 15px;
}
.active-only-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;
  margin-bottom: 12px;
}
.active-only-row label {
  width: 125px;
  font-size: 15px;
}
.checkbox-input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>
